<template>
    <div style="background:#FAFAFA;" class="policeLato">
    
      <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
      <section class="mt-5" v-if="isMobile()">
        <div class="paralax-cover-image_mobile has-background-dim_mobile">
          <p class="paralax-cover-image-text_mobile">
          <div class="content_home" style="z-index: 1!important;margin-top: 10%">
            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_auto.flotte_entreprise.header_title[0]')}}</span></h1>
            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('devis.devis_auto.flotte_entreprise.header_title[1]')}}</span></h1>
          </div>
          </p>
        </div>
      </section>
  
      <div>
        <div class="container" style="background:#FAFAFA">
          <div class="container justify-content-center row text-center mb-5 mt-5">
            <p class="mb-3"  style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">
              {{$t('devis.devis_auto.title[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_auto.title[1]') }}</span>
              {{ $t('devis.devis_auto.title[2]') }} <span class="font-weight-bold">{{ $t('devis.devis_auto.title[3]') }}</span>
            </p> <br>
          </div>
          <br>
  
          <div class="row" style="background:#FAFAFA" v-if="isMobile()">
            <div class="col-md-10" style="background:#FAFAFA">
              <div class="form" style="background:#FAFAFA">
                <div class="wizard-navigation">
                  <div class="wizard-progress-with-circle">
                    <div class="wizard-progress-bar"
                      style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                  </div>
                  <div class="progress-bar-group">
                    <div class="progress-bar-custom" id="testup"></div>
                  </div>
                  <ul role="tablist" class="wizard-nav wizard-nav-pills">
                    <li class="step" id="firstStep">
                      <div class="step-title text-center mr-4">{{ $t('devis.devis_auto.flotte_entreprise.devis_flotte.telecharger_flotter_stepper_mobile_label') }}</div>
                    </li>
                    <li class="step" id="thirstStep">
                      <div class="step-title text-center mr-4">{{ $t('devis.devis_auto.stepper_title[2]') }}</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     ================= -->
          <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
          <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
          <!-- ========================================================================================= -->
          <div v-responsive.sm.xs>
            <div class="mt-5" style="background:#FAFAFA">
              <div class="row" style="background:#FAFAFA">
                <div class="col-md-10 ml-2" style="background:#FAFAFA">
                  <div class="form" style="background:#FAFAFA">
                    <div class="page" v-show="step === 1">
                     <div class="container justify-content-center row text-center">
                  <label for="images" id="dropcontainer" class="drop-container">
                    <span class="drop-title">{{ $t('devis.devis_auto.flotte_entreprise.devis_flotte.deposer_label') }}</span>
                    <input class="mb-3" @change="filesChange($event.target.files);fileCount = $event.target.files.length" type="file" id="images" name="fileExcel" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" required="required">
                    <!-- <div class="wizard-footer-right mt-3">
                      <button type="button" class="wizard-btn" @click="checkFlotteFile">Uploader</button>
                    </div> -->
                  </label>
                 
                </div>
                    </div>
  
                    <div class="page review_page" v-show="step === 2">
                      <div class="wizard-tab-content">
                        <div role="tabpanel" id="Step10_mobile" aria-hidden="true" aria-labelledby="step-Step10_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="fields">
                              <div class="field-title">
                                {{ $t('devis.devis_auto.choix_assureurs') }}&nbsp;:
                              </div>

                              <!-- Grid moderne pour les assureurs -->
                              <div class="insurers-grid">
                                <!-- Bouton "Tous" -->
                                <div class="insurer-card all-insurers" :class="{ 'selected': selectAll }">
                                  <input v-model="selectAll" type="checkbox" id="tous_mobile" class="insurer-input">
                                  <label for="tous_mobile" class="insurer-label">
                                    <div class="insurer-icon">
                                      <img src="../../assets/img/icones/all.png" alt="Tous les assureurs" class="insurer-logo">
                                    </div>
                                    <div class="insurer-info">
                                      <h4 class="insurer-name">{{ $t('devis.devis_auto.bouton_tous') }}</h4>
                                      <span class="insurer-badge">Tous</span>
                                    </div>
                                    <div class="selection-indicator">
                                      <i class="fas fa-check"></i>
                                    </div>
                                  </label>
                                </div>

                                <!-- Cartes des assureurs -->
                                <div 
                                  class="insurer-card" 
                                  v-for="assure in listeAssureurs" 
                                  :key="assure._id"
                                  :class="{ 'selected': assureurs.includes(assure.societe) }"
                                >
                                  <input 
                                    v-model="assureurs" 
                                    type="checkbox" 
                                    :value="assure.societe" 
                                    :id="assure.societe"
                                    class="insurer-input"
                                  >
                                  <label :for="assure.societe" class="insurer-label">
                                    <div class="insurer-icon">
                                      <img :src="assure.logo" :alt="assure.societe" class="insurer-logo">
                                    </div>
                                    <div class="insurer-info">
                                      <h4 class="insurer-name">{{ assure.societe }}</h4>
                                      <span class="insurer-badge">Assureur</span>
                                    </div>
                                    <img v-if="assure.is_car_attestation_ready" class="lightning-box" src="../../assets/img/lightning.png" width="20" alt="lightning_logo">
                                    <div class="selection-indicator">
                                      <i class="fas fa-check"></i>
                                    </div>
                                  </label>
                                </div>
                              </div>

                              <!-- Résumé de la sélection -->
                              <div class="selection-summary" v-if="assureurs.length > 0">
                                <div class="summary-content">
                                  <i class="fas fa-info-circle"></i>
                                  <span>{{ assureurs.length }} {{ $t('devis.devis_auto.assureur_label') }}{{ assureurs.length > 1 ? 's' : '' }} {{ $t('devis.devis_auto.selectionne_label') }}{{ assureurs.length > 1 ? 's' : '' }}</span>
                                </div>
                              </div>
                              <!-- <div class="field-group row field-bank">
                                <div class="btn-choice col-sm-6 col-6">
                                  <input v-model="selectAll" type="checkbox" id="tous_mobile" class="field-input">
                                  <label for="tous_mobile" class="field-label" label="Tous">
                                    <img src="../../assets/img/icones/all.png" alt="Tous_mobile" height="60" width="60">
                                    <p class="field-title" style="margin-top:-12px;margin-bottom:-10px;color:#ffa409">{{
                                      $t('devis.devis_auto.bouton_tous') }}</p>
                                  </label>
                                </div>
                                <div class="btn-choice col-sm-6 col-6" v-for="assure in listeAssureurs" :key="assure._id">
                                  <input v-model="assureurs" type="checkbox" :value="assure.societe" :id="assure.societe"
                                    class="field-input">
                                  <label :for="assure.societe" class="field-label" :label="assure.societe">
                                      <span v-if="assure.is_car_attestation_ready">
                                        <img class="lightning-box" src="../../assets/img/lightning.png" width="20" alt="lightning_logo">
                                    </span>
                                    <img :src="assure.logo" alt="partenaire logo" height="50">
                                    <p class="field-title" style="margin-top:-3px;margin-bottom:-10px">
                                      {{ assure.societe }}</p>
                                  </label>
                                </div>
                              </div> -->
                            </div>
                          </div>
                        </div>
  
                        <div role="tabpanel" id="Step11_mobile" aria-hidden="true" aria-labelledby="step-Step11_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="loan-group loan-group-0">
                              <div class="fields">
                                <div class="field-title">{{ $t('devis.devis_auto.periode_garantie_title') }}&nbsp;:</div>
                                <div class="row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper38_mobile" class="field-label">{{
                                        $t('devis.devis_auto.duree_garantie') }}
                                        <button type="button" tabindex="-1" title="" class="field-help"
                                          data-original-title="Taux d'intérêt"></button></label>
                                      <div class="input-group rate-loan">
                                        <select @change="dateDiff()" v-model="duree" id="Stepper24" name="Step8"
                                          class="field-select">
                                          <option v-for="item in DureeMois" :key="item" :value="item">{{ item }}</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
  
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper39_mobile" class="field-label">{{ $t('devis.devis_auto.date_effet')
                                      }}
                                        <button type="button" tabindex="-1" title="" class="field-help"
                                          data-original-title="Taux d'intérêt"></button></label>
                                      <div class="input-group rate-loan">
                                        <date-picker id="Stepper39_mobile" :disabled-date="disabledAfterToday"
                                          :editable="false" class="field-input mb-1 mt-1" placeholder="Cliquer ici"
                                          @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)"
                                          v-model="dateEffet" valueType="format" format="YYYY-MM-DD"
                                          lang="fr-fr"></date-picker>
                                      </div>
                                    </div>
                                  </div>
  
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper40_mobile" class="field-label">{{
                                        $t('devis.devis_auto.date_echeance') }}
                                        <button type="button" tabindex="-1" title="" class="field-help"
                                          data-original-title="Taux d'intérêt"></button></label>
                                      <div class="input-group rate-loan">
                                        <input disabled placeholder="Date d'échéance" v-model="dateEcheance"
                                          id="Stepper40_mobile" name="Step11_mobile" class="field-input">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
  
                        <div role="tabpanel" id="Step12_mobile" aria-hidden="true" aria-labelledby="step-Step12_mobile"
                          class="wizard-tab-container">
                          <div>
                            <div class="loan-group loan-group-0">
                              <div class="fields">
                                <div class="field-title">{{ $t('devis.devis_auto.beneficiaire') }}&nbsp;:</div>
                                <div class="row">
                                  <div class="col-sm-4 mt-5">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <div class="field-checkbox">
                                        <div class="field-label">
                                          {{ $t('devis.devis_auto.idem_compte') }}
                                        </div>
                                        <div class="switch">
                                          <label for="Stepper41_mobile">
                                            <input @change="switchBenef()" v-model="switch1" type="checkbox"
                                              id="Stepper41_mobile" name="Step12_mobile">
                                            <span class="lever"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
  
                                  <div class="col-sm-6">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper42_mobile" class="field-label">{{ $t('devis.devis_auto.nom_carte_grise_label') }}
                                        <button type="button" tabindex="-1" title="" class="field-help"
                                          data-original-title="Taux d'intérêt"></button></label>
                                      <div class="input-group rate-loan">
                                        <input :disabled="disabledBenefInput" @click="dialogInfoBeneficiaire = true" :placeholder="$t('devis.devis_auto.nom_et_prenom')" v-model="proprietaire"
                                          id="Stepper42_mobile" name="Step12_mobile" class="field-input">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                          <button @click="BacktoFiveStep()" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{ $t('devis.devis_auto.bouton_retour') }}
                          </button>
                        </div>
                        <div class="wizard-footer-right">
                          <button :disabled="disabledButtonValidate" v-if="nbAutoAdded >= nombreVehicules"
                            @click="SendDataToCreateDevisFlotte()" type="button" class="wizard-btn">
                            {{ $t('devis.devis_auto.bouton_valider') }}
                          </button>
                        </div>
                        <!---->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!--    ==========================Modal for cars mobile ============================================ -->
      <v-dialog persistent v-model="ModalListeContrat" v-if="isMobile()" style="width:100%!important">
        <v-card tile class="border-radius policeLato">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="UserCarTable" aria-hidden="true" aria-labelledby="step-UserCarTable"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.my_vehicule') }}&nbsp;:</div>
                      <p>{{ $t('devis.devis_auto.nombre_vehicule_flotte[0]') }}<span class="font-weight-bold">{{tableData.length}}</span> {{ $t('devis.devis_auto.nombre_vehicule_flotte[1]') }}</p>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="col-sm-12">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <input v-model="searchCarDesktop" :placeholder="$t('devis.devis_auto.chercher')"
                                id="Stepper288" name="Step8" class="field-input">
                            </div>
                          </div>
  
                          <v-flex style="background-color: #FAFAFA!important;z-index:10000">
                            <v-data-table :headers="$t('devis.devis_auto.headerVehiculeFlotteMobile')" :items="tableData"
                              :search="searchCarDesktop" class="border-radius mt-2 mb-5"
                              style="background-color: #FAFAFA!important">
                              <template slot="items" slot-scope="props">
                                <td>{{ props.item.marque }}</td>
                                <td>{{ props.item.immatriculation }}</td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="closePopupCar()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                  <button @click="validVehicule()" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_suivant') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  
  
      <!-- ========= DIALOG POUR LES INFORMATIONS DU BENEFICIAIRES AU CAS OU C 'EST PAS CELUI QUI EST CONNECTÉ ============ -->
      <!-- ========= DIALOG POUR LES INFORMATIONS DU BENEFICIAIRES AU CAS OU C 'EST PAS CELUI QUI EST CONNECTÉ ============ -->
      <v-dialog v-model="dialogInfoBeneficiaire" persistent max-width="1000">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('devis.devis_auto.infos_benef_title') }}&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="col-sm-12 field-radio field-radio-center">
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Femme" id="Homme" name="infosPerso"
                                class="field-input">
                              <label for="Homme" class="field-label btn-choice-hide-dot">{{
                                $t('devis.devis_auto.infos_benef_content[0]') }}</label>
                            </div>
                            <div class="btn-choice">
                              <input v-model="genre" type="radio" value="Homme" id="Femme" name="infosPerso"
                                class="field-input">
                              <label for="Femme" class="field-label btn-choice-hide-dot">{{
                                $t('devis.devis_auto.infos_benef_content[1]') }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="row mt-3">
                        <div class="col-sm-6">
                          <div class="field-group field-default">
                            <label for="prenom_benef" class="field-label">
                              {{ $t('devis.devis_auto.infos_benef_content[2]') }}*
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="prenom_beneficiaire" placeholder="Votre prenom" id="prenom_benef"
                                name="infosPerso" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="nom_benef" class="field-label">{{ $t('devis.devis_auto.infos_benef_content[3]')
                            }}*</label>
                            <input v-model="nom_beneficiaire" placeholder="Votre nom" id="nom_benef" name="infosPerso"
                              class="field-input">
                          </div>
                        </div>
                      </div>
  
                      <div class="row mt-3">
                        <div class="col-sm-6">
                          <div class="field-group field-default">
                            <label for="num_benef" class="field-label">
                              {{ $t('devis.devis_auto.infos_benef_content[4]') }}
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input v-model="num_beneficiaire" @keypress="onlyNumber" id="num_benef" name="infosPerso" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="email_benf" class="field-label">{{ $t('devis.devis_auto.infos_benef_content[5]')
                            }}</label>
                            <input v-model="email_beneficiaire" placeholder="xxxxxx@xxxxx.com" id="email_benf"
                              name="infosPerso" class="field-input">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="annulerBenef()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="Detail_info_beneficiaire()" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_ajouter') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <div v-if="dialogLoading && isMobile" class="loading-state">
          <div class="loading"></div>
          <span class="ml-3 loading-text">{{ $t('devis.devis_auto.devis_encours')}}</span>
      </div>

      <div v-if="dialogLoadingFile" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('devis.devis_auto.flotte_entreprise.traitemant_label')}}</span>
      </div>
  
      <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
      <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>
    </div>
  </template>
  
  <script>
  import dayjs from 'dayjs'
  import MarqueVehicule from '../../common/marqueauto'
  import Marque2roues from '../../common/2roues'
  import _ from 'underscore'
  import Api from '../../services/Api'
  import store from '../../store/store'
  import LoginForm from '../auth/Login'
  import { mask } from 'vue-the-mask'
  import configAuto from '../../common/configAuto'
  import PushInDataLayer from '../../services/TagManager'
  import listeTalonFromPartenerApi from "../../common/TalonDigitalPartener.json"
  
  export default {
    name: 'Auto',
    components: {
      LoginForm
    },
    directives: {
      mask,
    },
    data() {
      return {
        listeTalonFromPartener: listeTalonFromPartenerApi,
        deleteConfirmationCar : false,
        confirmdelete: null,
        disabledBenefInput : false,
        GarantiesBase: [],
        Garanties2roues: [],
        dialogLoading: false,
        disabledButtonValidate: false,
        DureeMois: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        searchCarDesktop: "",
        nombreVehicule: 0,
        carDetails: {},
        disableMyCars: false,
        myCars: null,
        headerContrat: [
          {
            text: "Marque",
            sortable: false,
            value: "marque"
          },
          {
            text: "Modele",
            sortable: false,
            value: "model"
          },
          {
            text: "Immatriculation",
            sortable: false,
            value: "Immatriculation"
          },
          {
            text: "Nombre de places",
            sortable: false,
            value: "nbplace"
          },
          {
            text: "Force",
            sortable: false,
            value: "force"
          },
          {
            text: "Date 1ère Circulation",
            sortable: false,
            value: "dateCircule"
          },
          {
            text: "Valeur actuelle",
            sortable: false,
            value: "valeur_venale"
          },
          {
            text: "Action",
            value: "action"
          }
        ],
        headerContratMobile: [
          {
            text: "Marque",
            sortable: false,
            value: "marque"
          },
          {
            text: "Modele",
            sortable: false,
            value: "model"
          },
          {
            text: "Immatriculation",
            sortable: false,
            value: "Immatriculation"
          }
        ],
        ModalListeContrat: false,
        listCars: [],
        userCars: [],
        showOffre: true,
        offre_full: false,
        PackFull_Choix: null,
        text_packStandart: false,
        text_packInter: false,
        text_packAvance: false,
        text_packFull_1: false,
        text_packFull_2: false,
        text_packFull_3: false,
        offre: 'offre_pack',
        offre_pack: true,
        offre_pack_full: false,
        offre_carte: false,
        packS: '',
        packI: '',
        packA: '',
        packStandart: {
          garanties: ['RESPONSABILITE CIVILE', 'PERSONNES TRANSPORTEES', 'DEFENSE ET RECOURS']
        },
        packIntermediaire: {
          garanties: ['RESPONSABILITE CIVILE', 'PERSONNES TRANSPORTEES', 'DEFENSE ET RECOURS', 'BRIS DE GLACES']
        },
        packAvance: {
          garanties: ['RESPONSABILITE CIVILE', 'PERSONNES TRANSPORTEES', 'DEFENSE ET RECOURS', 'BRIS DE GLACES', 'VOL', 'INCENDIE', 'AVANCE SUR RECOURS']
        },
        packFull: {
          packFullToutRisques: {
            garanties: ['RESPONSABILITE CIVILE', 'PERSONNES TRANSPORTEES', 'DEFENSE ET RECOURS', 'BRIS DE GLACES', 'VOL', 'INCENDIE', 'AVANCE SUR RECOURS', 'TIERCE COMPLETE']
          },
          packFullCollision: {
            garanties: ['RESPONSABILITE CIVILE', 'PERSONNES TRANSPORTEES', 'DEFENSE ET RECOURS', 'BRIS DE GLACES', 'VOL', 'INCENDIE', 'AVANCE SUR RECOURS', 'TIERCE COLLISION']
          }
        },
        showMarqueSelect: false,
        showMarque2roueSelect: false,
        step: 1,
        neant: 'N.A',
        annee: null,
        VNeuf: false,
        dialogInfoBeneficiaire: false,
        switch1: false,
        mask: 'XX-XXXX-XX',
        selected: [],
        genre: null,
        money: {
          thousands: ' ',
          precision: false,
          masked: false,
        },
        forceFis: false,
        dateCircul: false,
        carteNouvelle: false,
        carteAncienne: false,
        dateNouvelle: false,
        dateAncienne: false,
        itemsGenre: ['Homme', 'Femme'],
        max: 10,
        itemsFlotte: ['2', '3', '4', '5', '6', '7', '8', '9'],
        items: ['2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
        items2roues: ['1', '2'],
        PuissanceFinscaleItems: ['2', '3', '4', '5', '6', '7', '8', '9', '10', 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, '24+'],
        date: new Date().toISOString().substr(0, 10),
        menu: false,
        popupAutre: false,
        popupAddGaranties: false,
        datePickerAge: false,
        modal: false,
        menu1: false,
        dialog: false,
        AvRec: false,
        type_vitre: null,
        AvRecModal: false,
        AvRecAddNew: false,
        PersoTransporteModal: false,
        e1: 0,
        marque: null,
        ToastTabSucess: {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 4000,
          fitToScreen: true,
          type: 'success',
          className: 'custom-success-class'
        }, // Customized options for success toast
        ToastTabError: {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 4000,
          fitToScreen: true,
          type: 'error'
        }, // Customized options for error toast
        ToastTabErrorSpec: {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 10000,
          fitToScreen: true,
          type: 'error'
        }, // Customized options for error toast
        model: null,
        categorie: null,
        categorieFInale: null,
        volumetrie2_roues: null,
        tonnage: null,
        tonnage_carosserie: null,
        annee_mois: null,
        dialogEditItem: false,
        capital_AvRec: null,
        force: null,
        nbBeneficiaire: null,
        optionPersoTrans: null,
        flotte_mono: null,
        clickTCollision_TComplete: false,
        nombreVehicules: null,
        HideNbVehicule: true,
        optionUtilitaire: null,
        carosserie: null,
        option_Individuel_Accident: null,
        dateCircule: null,
        age: null,
        year: null,
        nbplace: null,
        dateEffet: new Date().toISOString().substr(0, 10),
        dateEcheance: null,
        proprietaire: '',
        prenom_beneficiaire: '',
        nom_beneficiaire: '',
        num_beneficiaire: '',
        email_beneficiaire: '',
        duree: null,
        yearDiff: null,
        tableau_info_beneficiaire: [],
        listeAssureurs: [],
        assureurs: [],
        valeur: null,
        CarToUpdate: null,
        valeur_venale: null,
        immatriculation: null,
        numeroChassis : null,
        showLoginForm: false,
  
        carburant: null,
        garanties: [],
        hideTablr: true,
        Individuel_Accident_Modal: false,
        typeAssurance: 'AUTO/MOTO',
        voidField: false,
        carburation: [
          {
            "lib": "Essence",
            "val": "Essence"
          },
          {
            "lib": "Diesel",
            "val": "Diésel"
          },
          {
            "lib": "Hybride",
            "val": "Hybride"
          },
          {
            "lib": "Electrique",
            "val": "Electrique"
          },
        ],
        ListAuto: [],
        listeMarque: MarqueVehicule,
        listeMarque2roues: Marque2roues,
        listeModeles: null,
        listeModeles2roues: null,
        selectedMarque: null,
        nbAutoAdded: 0,
        headers: [{
          text: 'Marque & Modèle',
          value: 'marque'
        },
        {
          text: 'Immatriculation',
          value: 'immatriculation'
        },
        {
          text: 'Catégorie',
          value: 'catégorie'
        },
        {
          text: 'Force',
          value: 'force'
        },
        {
          text: 'Age',
          value: 'age'
        },
        {
          text: 'Valeur neuf',
          value: 'valeur'
        },
        {
          text: 'Valeur actuelle',
          value: 'valeur_actuelle'
        },
        {
          text: 'Nbr places',
          value: 'nbplace'
        },
        {
          text: 'Actions'
        }
        ],
        editedIndex: -1,
        editedItem: {
          marque: null,
          model: null,
          categorie: null,
          force: 0,
          age: null,
          valeur: null,
          immatriculation: null,
          carburant: null,
        },
        defaultItem: {
          marque: null,
          model: null,
          categorie: null,
          force: 0,
          age: null,
          valeur: null,
          immatriculation: null,
          carburant: null,
        },
        suivant: false,
        suivantAddGarantie: false,

        tableData : [],
        file : null,
        reference_flotte : null,
        is_devis_flotte : true,
        dialogLoadingFile : false
      }
    },
    methods: {
      validVehicule(){
        this.ModalListeContrat = false
        this.step = 2
        document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFirst');
      },
      filesChange(fileList) {
         if (!this.$store.state.isUserLoggedIn) {
              this.showLoginForm = true
          }else{
              if (!fileList.length) return;
      this.file = fileList[0];
      if(this.file){
          this.checkFlotteFile();
      }else {

      }
          }
    },
      checkFlotteFile() {
            if(this.file){
               const formData = new FormData();
      formData.append("excel", this.file);
      formData.append("userid", this.$store.state.user._id);
              this.dialogLoadingFile = true
      Api()
        .post("tempflotte/add", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((result) => {
          this.reference_flotte =  { id: result.data.vehicules[0].reference }
          this.tableData = result.data.vehicules;
            this.dialogLoadingFile = false
          if(this.tableData.length > 0){
            this.$toasted.show("Fichier Excel uploadé avec succès !", this.ToastTabSucess)
            this.ModalListeContrat = true
            this.clearInputFile()
          }else {
            this.clearInputFile()
            this.$toasted.show("Le fichier uploadé ne contient pas de véhicule!", this.ToastTabError)
          }
        })
        .catch((err) => {
          this.$toasted.show("Le format du fichier n'est pas reconnu!", this.ToastTabError)
          this.clearInputFile()
          this.dialogLoadingFile = false
        });
            }else {
              this.$toasted.show("Veuillez uploader un fichier pour continuer!", this.ToastTabError)
            }
             
    },

    clearInputFile(){
        const fileInput = document.querySelector('input[type="file"]');
  if (fileInput) {
    fileInput.value = '';
      // Reset related data
  //this.fileCount = 0;
  //this.tableData = [];
  }
    },
      confirmDeleteCar() {
        const UserCar = {
          id: this.confirmdelete._id
        }

        Api().post("flette/delete", UserCar)
          .then(response => {
            if (response.status == 200) {
              this.deleteConfirmationCar = false
              this.getUserCars()
              this.$toasted.show("Véhicule supprimé avec succès !", this.ToastTabSucess)
            }
          })
          .catch(err => { })
      },
      validateNumeroChassis() {
      const regex = /^[A-Za-z0-9-]+$/;
      if (!regex.test(this.numeroChassis)) {
        this.numeroChassis = this.numeroChassis.replace(/[^A-Za-z0-9-]/g, '');
      }
    },
      validateImmatriculation() {
      const regex = /^[A-Za-z0-9]{2}-[A-Za-z0-9]{4}-[A-Za-z0-9]{2}$/;
      if (!regex.test(this.immatriculation)) {
        this.immatriculation = this.immatriculation.replace(/[^A-Za-z0-9-]/g, '');
      }
    },
      checkToken() {
        Api().get('user/check/token')
          .then((resultat) => {
            // verifie si le token exist
            if (!resultat.data.ok) {
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          }).catch((err) => {
            // verifie  si le token est expiré
            if (err.response.data.ok === false) {
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          });
      },
  
      addGarantiesToClosePopup() {
        if (this.CarToUpdate.garanties.length >= 1) {
          this.popupAddGaranties = false
        } else {
          this.$toasted.show('Veuillez cocher une garantie au minimum ! ', this.ToastTabError)
        }
      },
  
      backToFirstStep() {
        this.step = 0
        this.myCars = null
      },
  
      closePopupCar() {
        this.ModalListeContrat = false
        while (this.tableData.length) {
          this.tableData.pop();
        }
      },
  
      getUserCars() {
        Api().post("flette/listing/", { userid: store.state.user._id })
          .then(response => {
            this.listCars = response.data.cars
          });
      },
  
      deleteUserCar(item) {
        this.deleteConfirmationCar = true
        this.confirmdelete = item
      },
  
      //Date object formater to String
      DateFormater: function (TheDate) {
        if (TheDate) {
          return dayjs(TheDate).format('DD-MM-YYYY')
        }
      },
  
      disabledBeforeToday(date) {
        const today = new Date();
        return date > today;
      },
  
      disabledAfterToday(date) {
        const today = dayjs(new Date()).add(-1, 'day')
        return date < today;
      },
  
      yearsDiffDateEffet() {
        const date1 = dayjs(this.dateEffet);
        const date2 = dayjs(new Date().toISOString().substr(0, 10));
        let daydiff = date2.diff(date1, 'days');
  
        this.ageArrivee = daydiff;
  
        if (this.ageArrivee > 0) {
          this.ageArrivee = null;
          this.annee_mois = '';
          this.$toasted.show('Erreur, date postérieure à la date actuelle! ', this.ToastTabError)
          this.dateEffet = null
  
        }
  
      },
      showGaranties() {
        if (this.garanties == this.packStandart.garanties) {
          this.optionPersoTrans = 'option 1'
          this.text_packStandart = true
          this.text_packInter = false
          this.text_packAvance = false
          this.offre_pack_full = false
          this.text_packFull_1 = false
          this.text_packFull_2 = false
          this.text_packFull_3 = false
          this.offre_full = false
        } else if (this.garanties == this.packIntermediaire.garanties) {
          this.optionPersoTrans = 'option 1'
          this.text_packStandart = false
          this.text_packInter = true
          this.text_packAvance = false
          this.offre_pack_full = false
          this.text_packFull_1 = false
          this.text_packFull_2 = false
          this.text_packFull_3 = false
          this.offre_full = false
        } else if (this.garanties == this.packAvance.garanties) {
          this.optionPersoTrans = 'option 1'
          this.capital_AvRec = '500000'
          this.text_packStandart = false
          this.text_packInter = false
          this.text_packAvance = true
          this.offre_pack_full = false
          this.text_packFull_1 = false
          this.text_packFull_2 = false
          this.text_packFull_3 = false
          this.offre_full = false
        } else if (this.garanties == this.packFull) {
          this.text_packStandart = false
          this.text_packInter = false
          this.text_packAvance = false
          this.offre_full = true
        }
      },
      showGarantiesPackFull() {
        if (this.garanties == this.packFull.packFullToutRisques.garanties) {
          this.optionPersoTrans = 'option 1'
          this.capital_AvRec = '500000'
          this.ValeurNeufModalFunction()
  
          this.text_packFull_1 = true
          this.text_packFull_2 = false
          this.text_packFull_3 = false
        } else if (this.garanties == this.packFull.packFullCollision.garanties) {
          this.optionPersoTrans = 'option 1'
          this.capital_AvRec = '500000'
          this.ValeurNeufModalFunction()
          this.text_packFull_1 = false
          this.text_packFull_2 = true
          this.text_packFull_3 = false
        } else if (this.garanties == this.packFull.packFull_3.garanties) {
          this.text_packFull_1 = false
          this.text_packFull_2 = false
          this.text_packFull_3 = true
        }
  
      },
      show_offre() {
        if (this.offre == 'offre_pack') {
          this.offre_pack = true
          this.offre_carte = false
          this.garanties = []
        } else if (this.offre == 'offre_carte') {
          this.offre_pack = false
          this.offre_carte = true
          this.text_packStandart = false
          this.text_packInter = false
          this.text_packAvance = false
          this.text_packFull_1 = false
          this.text_packFull_2 = false
          this.text_packFull_3 = false
          this.offre_full = false
          this.garanties = []
        }
      },
      showMarque() {
        this.showMarqueSelect = true
        this.marque = null
      },
      showMarque2roue() {
        this.showMarque2roueSelect = true
        this.marque = null
      },
      passFirstStep() {
        document.getElementById("sixStep").classList.add('checked');
        document.getElementById("testup").classList.add('widthSix');
      },
  
      BacktoFirstStep() {
        this.step = 1
        document.getElementById("firstStep").classList.remove('checked');
        document.getElementById("testup").classList.remove('widthSecond');
  
      },
  
      BacktoSecondStep() {
        this.step = 2
        document.getElementById("firstStep").classList.remove('checked');
        document.getElementById("testup").classList.remove('widthThirt');
  
      },
      BacktoThirstStep() {
        this.step = 3
        document.getElementById("firstStep").classList.remove('checked');
        document.getElementById("testup").classList.remove('widthFour');
  
      },
      BacktoFourStep() {
        if (this.categorie != '2_roues') {
          if (this.myCars == 'mes_vehicule') {
            this.step = 0
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("secondStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFive');
          } else {
            this.step = 4
            document.getElementById("secondStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFive');
          }
        } else if (this.categorie == '2_roues') {
          if (this.myCars == 'mes_vehicule') {
            this.step = 0
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("secondStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFive');
          } else {
            this.step = 3
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFour');
          }
  
        }
  
      },
      BacktoFiveStep() {
        this.step = 1
        this.ListAuto.pop()
        document.getElementById("firstStep").classList.remove('checked');
        document.getElementById("testup").classList.remove('widthFirst');
  
      },
  
      prev() {
        this.step--;
      },
      next() {
        this.step++;
      },
  
      validMarqueModel() {
        if (this.categorie == '2_roues') {
          if (this.marque && this.model && this.cylindre) {
            this.popupAutre = false
            this.next()
            document.getElementById("testup").classList.add('widthThirt');
          } else {
            this.$toasted.show('Champs obligatoires ! ', this.ToastTabError)
          }
        } else {
          if (this.marque && this.model) {
            this.popupAutre = false
            this.next()
            document.getElementById("testup").classList.add('widthThirt');
          } else {
            this.$toasted.show('Champs obligatoires ! ', this.ToastTabError)
          }
        }
      },
      /*============= fonction pour controler les garanties tierce a ne cocher plus d'un ===========*/
      tierceControl() {
        if (!this.CarToUpdate) {
          let cpt = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index].trim() == 'TIERCE COLLISION' || this.garanties[index].trim() == 'TIERCE PLAFONNEE') {
              cpt = cpt + 1
            } else if (this.garanties[index].trim() == 'TIERCE COLLISION' || this.garanties[index].trim() == 'TIERCE COMPLETE') {
              cpt = cpt + 1
            } else if (this.garanties[index].trim() == 'TIERCE COMPLETE' || this.garanties[index].trim() == 'TIERCE PLAFONNEE') {
              cpt = cpt + 1
            } else if (this.garanties[index].trim() == 'TIERCE COLLISION' || this.garanties[index].trim() == 'TIERCE PLAFONNEE' || this.garanties[index].trim() == 'TIERCE COMPLETE') {
              cpt = cpt + 2
            }
          }
          if (cpt == 2) {
            this.$toasted.show("Impossible de prendre 2 garanties tierces en même temps", this.ToastTabError);
            this.suivant = true
          } else if (cpt == 3) {
            this.$toasted.show("Impossible de prendre 3 garanties tierces en même temps", this.ToastTabError);
            this.suivant = true
          } else {
            this.ValeurNeufModalFunction()
            this.suivant = false
          }
        } else {
          let cpt = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE') {
              cpt = cpt + 1
            } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE') {
              cpt = cpt + 1
            } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE') {
              cpt = cpt + 1
            } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE' || this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE') {
              cpt = cpt + 2
            }
          }
          if (cpt == 2) {
            this.$toasted.show("Impossible de prendre 2 garanties tierces en même temps", this.ToastTabError);
            this.suivantAddGarantie = true
          } else if (cpt == 3) {
            this.$toasted.show("Impossible de prendre 3 garanties tierces en même temps", this.ToastTabError);
            this.suivantAddGarantie = true
          } else {
            this.ValeurNeufModalFunction()
            this.suivantAddGarantie = false
          }
        }
      },
  
      /*============= fonction pour controler les garanties tierce a ne cocher plus d'un ===========*/
      tierceControlAddGarantie() {
        let cpt = 0;
        for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
          if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE') {
            cpt = cpt + 1
          } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE') {
            cpt = cpt + 1
          } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE') {
            cpt = cpt + 1
          } else if (this.CarToUpdate.garanties[index].trim() == 'TIERCE COLLISION' || this.CarToUpdate.garanties[index].trim() == 'TIERCE PLAFONNEE' || this.CarToUpdate.garanties[index].trim() == 'TIERCE COMPLETE') {
            cpt = cpt + 2
          }
        }
        if (cpt == 2) {
          this.$toasted.show("Impossible de prendre 2 garanties tierces en même temps", this.ToastTabError);
          this.suivant = true
        } else if (cpt == 3) {
          this.$toasted.show("Impossible de prendre 3 garanties tierces en même temps", this.ToastTabError);
          this.suivant = true
        } else {
          this.ValeurNeufModalAddGarantiesFunction()
          this.suivant = false
        }
      },
  
      optionPersonneTransControl() {
        if (this.optionPersoTrans) {
          this.PersoTransporteModal = false
        } else {
          this.$toasted.show("Veuillez choisir une option!", this.ToastTabError)
        }
      },
      /*============= fonction du switch pour l'affichage du champ beneficiaire ===========*/
      switchBenef() {
        if (!this.$store.state.isUserLoggedIn) {
          this.showLoginForm = true
        } else if (this.switch1) {
          if (!this.$store.state.isUserLoggedIn) {
            this.showLoginForm = true;
            this.switch1 = false;
            this.proprietaire = ''
          } else {
            this.disabledBenefInput = true
            this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
          }
        } else {
          this.proprietaire = '';
          this.disabledBenefInput = false
          //this.dialogInfoBeneficiaire = true
        }
      },
  
      /*============= Action sur le button annuler du popup beneficiaire ===========*/
      annulerBenef() {
        this.dialogInfoBeneficiaire = false;
        //this.switch1 = true;
        //this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
      },
  
  
      /*============= Action sur le button valider infos du popup beneficiaire ===========*/
      Detail_info_beneficiaire() {
        if (this.prenom_beneficiaire && this.nom_beneficiaire) {
          //if (this.num_beneficiaire && this.email_beneficiaire) {
            let Beneficiaire = {
              prenom: this.prenom_beneficiaire,
              numero: this.num_beneficiaire,
              nom: this.nom_beneficiaire,
              email: this.email_beneficiaire,
              genre: this.genre
            };
            this.tableau_info_beneficiaire.push(Beneficiaire);
            this.proprietaire = this.prenom_beneficiaire + ' ' + this.nom_beneficiaire;
            this.dialogInfoBeneficiaire = false;
          // } else {
          //   this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
          // }
        } else {
          this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
        }
      },
  
      /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
      onlyNumber($event) {
        let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
        if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
          $event.preventDefault();
        }
      },
  
      /*============= Fonction pour calculer la date 1ere mise en circulation ===========*/
      yearsDiff() {
        const date1 = dayjs(this.dateCircule);
        const date2 = dayjs(new Date().toISOString().substr(0, 10));
        let daydiff = date2.diff(date1, 'days');
        this.age = daydiff;
  
        if (this.age < 0) {
          this.age = null;
          this.annee_mois = '';
          this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
          this.dateCircule = null
  
        } else if (this.age >= 360) {
          let year = Math.floor(this.age / 360);
          this.age = year;
          this.annee = year;
          this.year = this.age;
          this.an = this.annee_mois = 'an(s)'
        }
  
      },
  
      infoFiscale() {
        this.forceFis = !this.forceFis;
        this.carteNouvelle = false;
        this.carteAncienne = false;
      },
  
      infoDate() {
        this.dateCircul = !this.dateCircul;
        this.dateNouvelle = false;
        this.dateAncienne = false;
      },
  
      Option: function () {
        this.isHidden = !this.isHidden;
      },
  
      dateDiff: function () {
        if (this.dateEffet === '' && this.duree === '') this.dateEcheance = '';
        let inter = dayjs(this.dateEffet).add(this.duree, 'month').format('YYYY-MM-DD');
        this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
        this.yearsDiffDateEffet()
      },
  
      zeroControl() {
        if (this.duree <= 0) {
          this.duree = null
        }
      },
  
      numberMonth() {
        this.zeroControl()
        if (this.duree <= 12) {
          return true
        } else {
  
          return false
        }
      },
  
      isMobile: function () {
        if (screen.width <= 760) {
          return true
        } else {
          return false
        }
      },
  
      isTablette() {
        if (screen.width > 425 && screen.width <= 768) {
          return true
        } else {
          return false
        }
      },
  
      isDesktop: function () {
        if (screen.width > 768) {
          return true
        } else {
          return false
        }
      },
  
      CloseModalVNeuf: function () {
        let trouver = 0;
        for (let index = 0; index < this.garanties.length; index++) {
          if (this.garanties[index] == 'TIERCE COMPLETE') {
            trouver = 1
          }
        }
  
        if (trouver == 1 && !this.valeur || this.valeur == 0) {
          if (this.garanties == this.packFull.packFullToutRisques.garanties) {
            this.garanties = []
            this.text_packFull_1 = false
          }
          if (this.garanties == this.packFull.packFullCollision.garanties) {
            this.garanties = []
            this.text_packFull_2 = false
          }
          this.garanties.pop();
          this.VNeuf = false
        }
      },
  
      /* le user a choisi Avance Recours un popup apprait pour renseigner le capital Avance Recours*/
      /* alors si le user ferme le popup sans pour autant avoir renseigner le capital Avance Recours */
      /* on supprime la granties Avance Recours de la liste de ces garanties en executant CloseModalAvRec()*/
      CloseModalAvRec: function () {
        if (!this.CarToUpdate) {
          let trouver = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.capital_AvRec || this.capital_AvRec == 0) {
            this.garanties.pop();
            this.AvRec = false
          } else {
            this.garanties.pop();
            this.AvRec = false
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.CarToUpdate.capital_AvRec || this.CarToUpdate.capital_AvRec == 0) {
            this.CarToUpdate.garanties.pop();
            this.AvRecAddNew = false
          } else {
            this.CarToUpdate.garanties.pop();
            this.AvRecAddNew = false
          }
        }
  
      },
  
      /* le user a choisi Avance Recours un popup apprait pour renseigner le capital Avance Recours*/
      /* alors si le user ferme le popup sans pour autant avoir renseigner le capital Avance Recours */
      /* on supprime la granties Avance Recours de la liste de ces garanties en executant CloseModalAvRec()*/
      CloseModalAvRecWhenAddNewGaranties: function () {
        let trouver = 0;
        for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
          if (this.CarToUpdate.garanties[index] == 'AVANCE SUR RECOURS') {
            trouver = 1
          }
        }
  
        if (trouver == 1 && !this.CarToUpdate.capital_AvRec || this.CarToUpdate.capital_AvRec == 0) {
          this.CarToUpdate.garanties.pop();
          this.AvRecAddNew = false
        } else {
          this.CarToUpdate.garanties.pop();
          this.AvRecAddNew = false
        }
      },
  
      /* le user a choisi Avance Recours un popup apprait pour renseigner le capital Avance Recours*/
      /* alors si le user ferme le popup sans pour autant avoir renseigner le capital Avance Recours */
      /* on supprime la granties Avance Recours de la liste de ces garanties en executant CloseModalAvRec()*/
      CloseModalOptionTrans: function () {
        let trouver = 0;
        for (let index = 0; index < this.garanties.length; index++) {
          if (this.garanties[index] == 'PERSONNES TRANSPORTEES') {
            trouver = 1
          }
        }
  
        if (trouver == 1 && !this.optionPersoTrans || this.optionPersoTrans == 0) {
          this.garanties.pop();
          this.PersoTransporteModal = false
        } else {
          this.garanties.pop();
          this.PersoTransporteModal = false
        }
      },
  
      /* CheckCapitalAvRe est executée pour veririfer si le user à cocher ou decocher la garantie Avance Recours */
      /* si oui on affiche le popup pour demander le de renseigner capital Avance Recours sinon le popup reste fermé*/
      CheckCapitalAvRe: function () {
        if (!this.CarToUpdate) {
          let trouver = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.capital_AvRec || this.capital_AvRec == 0) {
            this.$toasted.show("Capital Avance sur recours obligatoires ! ", this.ToastTabError)
          } else if (trouver == 1 && this.capital_AvRec && this.capital_AvRec != 0) {
            this.AvRec = false
            if (this.garanties == this.packFull.packFullToutRisques.garanties) {
              this.tierceControl()
            } else if (this.garanties == this.packFull.packFullCollision.garanties) {
              this.tierceControl()
            }
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.CarToUpdate.capital_AvRec || this.CarToUpdate.capital_AvRec == 0) {
            this.$toasted.show("Capital Avance sur recours obligatoires ! ", this.ToastTabError)
          } else if (trouver == 1 && this.CarToUpdate.capital_AvRec && this.CarToUpdate.capital_AvRec != 0) {
            this.AvRecAddNew = false
          }
        }
  
      },
  
      AvRecModalFunction() {
        if (!this.CarToUpdate) {
          let trouver = 0
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
          if (trouver == 1) {
            this.AvRec = true
          } else {
            this.capital_AvRec = null
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'AVANCE SUR RECOURS') {
              trouver = 1
            }
          }
          if (trouver == 1) {
            this.AvRecAddNew = true
          } else {
            this.CarToUpdate.capital_AvRec = null
          }
        }
  
      },
  
      CheckValeurNeuf: function () {
        if (!this.CarToUpdate) {
          let trouver = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'TIERCE COMPLETE' || this.garanties[index] == 'TIERCE COLLISION') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.valeur || this.valeur == 0) {
            this.$toasted.show("Veuiller saisir la valeur à neuf du véhicule ! ", this.ToastTabError)
          } else if (trouver == 1 && this.valeur && this.valeur != 0) {
  
            if (Number(this.valeur_venale.replace(/[^0-9.-]+/g, "")) <= Number(this.valeur.replace(/[^0-9.-]+/g, ""))) {
              this.VNeuf = false
            } else {
              this.$toasted.show('La valeur à neuf et la actuelle du véhicule ne sont pas cohérentes !', this.ToastTabError)
            }
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'TIERCE COMPLETE' || this.CarToUpdate.garanties[index] == 'TIERCE COLLISION') {
              trouver = 1
            }
          }
  
          if (trouver == 1 && !this.valeur || this.valeur == 0) {
            this.$toasted.show("Veuiller saisir la valeur à neuf du véhicule ! ", this.ToastTabError)
          } else if (trouver == 1 && this.valeur && this.valeur != 0) {
  
            if (Number(this.valeur_venale.replace(/[^0-9.-]+/g, "")) <= Number(this.valeur.replace(/[^0-9.-]+/g, ""))) {
              this.VNeuf = false
            } else {
              this.$toasted.show('La valeur à neuf et la actuelle du véhicule ne sont pas cohérentes !', this.ToastTabError)
            }
          }
        }
      },
  
      CheckValeurNeufAddGaranties: function () {
        let trouver = 0;
        for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
          if (this.CarToUpdate.garanties[index] == 'TIERCE COMPLETE' || this.CarToUpdate.garanties[index] == 'TIERCE COLLISION') {
            trouver = 1
          }
        }
  
        if (trouver == 1 && !this.valeur || this.valeur == 0) {
          this.$toasted.show("Veuiller saisir la valeur à neuf du véhicule ! ", this.ToastTabError)
        } else if (trouver == 1 && this.valeur && this.valeur != 0) {
  
          if (Number(this.valeur_venale.replace(/[^0-9.-]+/g, "")) <= Number(this.valeur.replace(/[^0-9.-]+/g, ""))) {
            this.VNeuf = false
          } else {
            this.$toasted.show('La valeur à neuf et la actuelle du véhicule ne sont pas cohérentes !', this.ToastTabError)
          }
        }
      },
  
      /* On affiche le popup pour ajouter des garanties supplementaires a un vehicule(item) */
      AddGaranties(item) {
        this.CarToUpdate = item;
        this.popupAddGaranties = true
      },
  
      /*==========CETTE PARTIE EST SPECIALEMENT POUR UNE SERIE DE FONCTION PERMETTANT DE VALIDER LES MODELS POUR CHAQUE STEPPER========*/
      //Validation des elements du Stepper 1
      Stepper1Validator() {
        if (this.flotte_mono) {
          if (this.flotte_mono === 'flotte') {
            if (this.nombreVehicules) {
              //document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFirst');
              this.next()
              this.HideNbVehicule = true
            } else {
              this.$toasted.show('Nombre de véhicules !', this.ToastTabError)
            }
          } else {
            this.next()
            //document.getElementById("firstStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFirst');
            this.HideNbVehicule = false
          }
        } else {
          this.$toasted.show('Véhicule individuel ou Flotte automobile obligatoire ', this.ToastTabError)
        }
      },
  
      getListVehicule() {
        if (!store.state.isUserLoggedIn) {
          this.$toasted.show('Identifiez-vous pour une meilleure expérience !', this.ToastTabError)
          this.showLoginForm = true
        } else {
          this.ModalListeContrat = true
          this.listCars = this.userCars
          this.myCars = 'mes_vehicule'
        }
        this.getUserCars()
      },
  
      myCarValidator() {
        if (!store.state.isUserLoggedIn) {
          if (this.myCars == 'nouveau') {
            this.step = 1
          }
        } else {
          if (this.myCars == 'nouveau') {
            this.step = 1
          }
        }
      },
  
      getCarForDevis(item) {
        this.carDetails = item
  
        const date1 = dayjs(this.carDetails.dateCircule);
        const date2 = dayjs(new Date().toISOString().substr(0, 10));
        let daydiff = date2.diff(date1, 'days');
        this.age = daydiff;
  
        if (this.age >= 360) {
          let year = Math.floor(this.age / 360);
          this.age = year;
          this.annee = year;
          this.year = this.age;
          this.an = this.annee_mois = 'an(s)'
        }
  
        if (this.carDetails.categorie == 'categorie 5') {
          this.categorie = '2_roues'
          this.offre_carte = true
          this.showOffre = false;
        } else if (this.carDetails.categorie != 'categorie 5') {
          this.categorie = null
          this.offre_carte = false
          this.showOffre = true;
          this.offre_pack = true
        }
  
        this.nbAutoAdded = this.nbAutoAdded + 1;
        this.flotte_mono = 'mono'
        this.step = 5
        this.ModalListeContrat = false
        document.getElementById("firstStep").classList.add('checked');
        document.getElementById("testup").classList.add('widthFive');
      },
  
      //Validation des ellements du Stepper 2
      Stepper2Validator() {
        if (this.categorie) {
          switch (this.categorie) {
            case '2_roues':
              if (this.volumetrie2_roues) {
                //if (this.carburant){
                this.next()
                //document.getElementById("secondStep").classList.add('checked');
                document.getElementById("testup").classList.add('widthSecond');
                //}else {
                //  this.$toasted.show('La carburation du véhicule est obligatoire', this.ToastTabError)
                // }
              } else {
                this.$toasted.show('la volumetrie 2 roues est obligatoire ', this.ToastTabError)
              }
              break;
  
            case 'utilitaire':
              if (this.optionUtilitaire) {
                if (this.tonnage_carosserie) {
                  if (this.carburant) {
                    this.next()
                    //document.getElementById("secondStep").classList.add('checked');
                    document.getElementById("testup").classList.add('widthSecond');
                  } else {
                    this.$toasted.show('La carburation du véhicule est obligatoire', this.ToastTabError)
                  }
                } else {
                  this.$toasted.show('Tonnage et carosserie du véhicule', this.ToastTabError)
                }
              } else {
                this.$toasted.show('Veuillez renseigner le type du véhicule', this.ToastTabError)
              }
              break;
  
            case 'tourisme':
              if (this.carburant) {
                this.next()
                //document.getElementById("secondStep").classList.add('checked');
                document.getElementById("testup").classList.add('widthSecond');
              } else {
                this.$toasted.show('La carburation du véhicule est obligatoire', this.ToastTabError)
              }
              break;
          }
        } else {
          this.$toasted.show('La categorie du véhicule est obligatoire ', this.ToastTabError)
        }
      },
  
      //Validation des elements du Stepper 3
      Stepper3Validator() {
        if (this.categorie !== '2_roues') {
          if (this.marque) {
            if (this.model) {
              this.next()
              //document.getElementById("thirstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthThirt');
            } else {
              this.$toasted.show('Veuillez choisir le model du véhicule! ', this.ToastTabError)
            }
          } else {
            this.$toasted.show('Veuillez choisir la marque du véhicule! ', this.ToastTabError)
          }
        } else {
          if (this.marque) {
            if (this.model) {
              this.next()
              document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFour');
  
            } else {
              this.$toasted.show('Veuillez choisir le model du véhicule! ', this.ToastTabError)
            }
          } else {
            this.$toasted.show('Veuillez choisir la marque du véhicule! ', this.ToastTabError)
          }
        }
  
      },
  
      //Validation des elements du Stepper 4
      Stepper4Validator() {
        this.Deduction_tonnage_carosserie();
        if (this.categorie !== '2_roues') {
          if (this.force) {
            if (this.dateCircule) {
              if (this.nbplace) {
                this.Stepper5Validator()
              } else {
                this.$toasted.show('Veuiller saisir le nombre de place du véhicule! ', this.ToastTabError)
              }
  
            } else {
              this.$toasted.show("Veuiller saisir la date 1ère mise en circulation du véhicule!", this.ToastTabError)
            }
          } else {
            this.$toasted.show('Veuiller saisir la puissance du véhicule! ', this.ToastTabError)
          }
        } else {
          this.offre_carte = true
          this.showOffre = false;
          this.Stepper5Validator()
        }
  
      },
  
      //Validation des elements du Stepper 5
      Stepper5Validator() {
        this.Deduction_tonnage_carosserie()
        if (!this.$store.state.isUserLoggedIn) {
          this.switch1 = false
        }
        if (this.categorieFInale == 'categorie 5') {
          if (this.immatriculation) {
            if(this.numeroChassis == null){
              this.next()
              document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFour');
            } else if(this.numeroChassis != "" && this.numeroChassis.length < 17) {
              this.$toasted.show('Le numéro de châssis du véhicule doit etre au moins 17 caracteres!', this.ToastTabError)
            } else {
              this.next()
              document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFour');
            }
          } else {
            this.$toasted.show('Veuiller saisir l\'immatriculation du véhicule!', this.ToastTabError)
          }
        } else {
          if (this.valeur_venale && Number(this.valeur_venale.replace(/[^0-9.-]+/g, "")) >= configAuto.valeurNeufMinimal_Autre_categorie) {
            if (this.immatriculation) {
              if(this.numeroChassis == null){
              this.next()
              document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFour');
            } else if(this.numeroChassis != "" && this.numeroChassis.length < 17) {
              this.$toasted.show('Le numéro de châssis du véhicule doit etre au moins 17 caracteres!', this.ToastTabError)
            } else {
              this.next()
              document.getElementById("firstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthFour');
            }
            } else {
              this.$toasted.show("Veuiller saisir l'immatriculation du véhicule!", this.ToastTabError)
            }
          } else {
  
            this.$toasted.show('Veuiller saisir la valeur actuelle du véhicule!', this.ToastTabError)
          }
        }
      },
  
      /*==========Fonction de deduction de la categorie du vehicule selon ces options ========*/
      Deduction_tonnage_carosserie() {
        if (this.categorie == 'tourisme') {
          this.categorieFInale = 'categorie 1'
        } else if (this.categorie == 'utilitaire' && this.optionUtilitaire == 'Pour Compte') {
          this.categorieFInale = 'categorie 2';
          if (this.tonnage_carosserie == "Autre carosserie jusqu'à 3,5 tonnes") {
            this.tonnage = '3,5 Tonnes';
            this.carosserie = 'autres carosseries'
          } else if (this.tonnage_carosserie == 'Autre carosserie plus de 3,5 tonnes') {
            this.tonnage = 'Plus de 3,5 Tonnes';
            this.carosserie = 'autres carosseries'
          } else if (this.tonnage_carosserie == 'carosserie tourisme') {
            this.tonnage = '3,5 Tonnes';
            this.carosserie = 'carosserie tourisme'
          }
        } else if (this.categorie == 'utilitaire' && this.optionUtilitaire == 'Pour Tiers') {
          this.categorieFInale = 'categorie 3';
          if (this.tonnage_carosserie == "Autre carosserie jusqu'à 3,5 tonnes") {
            this.tonnage = '3,5 Tonnes';
            this.carosserie = 'autres carosseries'
          } else if (this.tonnage_carosserie == 'Autre carosserie plus de 3,5 tonnes') {
            this.tonnage = 'Plus de 3,5 Tonnes';
            this.carosserie = 'autres carosseries'
          }
        } else if (this.categorie == '2_roues') {
          this.categorieFInale = 'categorie 5'
        }
      },
  
      /*==========Fonction de nettoyage du formulaire apres recuperation des datas========*/
      ClearForm: function () {
        this.marque = '';
        this.model = '';
        this.categorie = '';
        this.force = '';
        this.age = '';
        this.nbplace = '';
        this.valeur = '';
        this.valeur_venale = '';
        this.immatriculation = '';
        this.carburant = '';
        this.option_Individuel_Accident = null;
        this.optionPersoTrans = null;
        this.capital_AvRec = null;
        this.garanties = ['RESPONSABILITE CIVILE']
      },
  
      /*==========Fonction permettant de remplacer les carburations par leurs equivalences========*/
      AutreCarburation(carburantChecked) {
        if (carburantChecked == 'Hybride' || carburantChecked == 'Electrique') {
          return 'Essence'
        } else {
          return carburantChecked
        }
      },
  
      /*=================Creation d'une liste de vehicules pour affichage Recap===============*/
      ListAutoCreate: function () {
        this.Deduction_tonnage_carosserie();
        const Oneauto = {
          categorie: this.categorieFInale,
          tonnage: this.tonnage,
          optionUtilitaire: this.optionUtilitaire,
          volumetrie2_roues: this.volumetrie2_roues,
          optionPersoTrans: this.optionPersoTrans,
          carburation: this.AutreCarburation(this.carburant),
          type_vitre: this.type_vitre,
          marque: this.marque,
          carosserie: this.carosserie,
          model: this.model,
          force: this.force,
          dateCircule: this.dateCircule,
          age: this.age,
          annee_mois: this.annee_mois,
          nbplace: Number(this.nbplace),
          valeur: Number(this.valeur.replace(/[^0-9.-]+/g, "")),
          valeur_venale: Number(this.valeur_venale.replace(/[^0-9.-]+/g, "")),
          immatriculation: this.immatriculation,
          numeroChassis: this.numeroChassis,
          flotte_mono: this.flotte_mono,
          option_Individuel_Accident: this.option_Individuel_Accident,
          garanties: this.garanties
        };
        if (this.capital_AvRec != null) {
          Oneauto.capitalAvRec = Number(this.capital_AvRec.replace(/[^0-9.-]+/g, ""))
        }
        if (this.categorie == '2_roues') {
          Oneauto.force = this.neant;
          Oneauto.dateCircule = this.neant;
          Oneauto.valeur = this.neant;
          Oneauto.valeur_venale = this.neant;
          Oneauto.nbplace = 2
        }
  
        this.hideTablr = false;
        this.ListAuto.push(Oneauto);
  
        this.nbAutoAdded = this.nbAutoAdded + 1;
  
        this.ClearForm();
        if (this.nombreVehicules > 1) {
          if (this.nbAutoAdded < this.nombreVehicules) {
            this.step = 2
            document.getElementById("testup").classList.add('widthSecond');
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFour', 'widthThirt', 'widthSecond');
          }
          if (this.nbAutoAdded == this.nombreVehicules) {
            this.step = 6
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
          }
        } else {
          this.voidField = true
        }
      },
  
      /*=================Creation d'une liste de vehicules pour affichage Recap===============*/
      ListAutoCreateForCars: function () {
        this.Deduction_tonnage_carosserie();
        const Oneauto = {
          categorie: this.carDetails.categorie,
          tonnage: this.carDetails.tonnage,
          optionUtilitaire: this.carDetails.optionUtilitaire,
          volumetrie2_roues: this.carDetails.volumetrie2_roues,
          optionPersoTrans: this.optionPersoTrans,
          carburation: this.carDetails.carburation,
          type_vitre: this.carDetails.type_vitre,
          marque: this.carDetails.marque,
          carosserie: this.carDetails.carosserie,
          model: this.carDetails.model,
          force: this.carDetails.force,
          dateCircule: this.carDetails.dateCircule,
          age: this.carDetails.age,
          annee_mois: this.carDetails.annee_mois,
          nbplace: this.carDetails.nbplace,
          valeur: this.carDetails.valeur,
          valeur_venale: this.carDetails.valeur_venale,
          immatriculation: this.carDetails.immatriculation,
          numeroChassis: this.carDetails.numeroChassis,
          flotte_mono: this.carDetails.flotte_mono,
          option_Individuel_Accident: this.carDetails.option_Individuel_Accident,
          garanties: this.garanties
        };
        if (this.capital_AvRec != null) {
          Oneauto.capitalAvRec = Number(this.capital_AvRec.replace(/[^0-9.-]+/g, ""))
        }
        if (this.categorie == '2_roues') {
          Oneauto.force = this.neant;
          Oneauto.dateCircule = this.neant;
          Oneauto.valeur = this.neant;
          Oneauto.valeur_venale = this.neant;
          Oneauto.nbplace = 2
        }
  
        this.hideTablr = false;
        this.ListAuto.push(Oneauto);
  
        this.nbAutoAdded = this.nbAutoAdded + 1;
  
        this.ClearForm();
        if (this.nombreVehicules > 1) {
          if (this.nbAutoAdded < this.nombreVehicules) {
            this.step = 2
            document.getElementById("testup").classList.add('widthSecond');
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFour', 'widthThirt', 'widthSecond');
          }
          if (this.nbAutoAdded == this.nombreVehicules) {
            this.step = 6
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
          }
        } else {
          this.voidField = true
        }
      },
  
      /*=================Recuperation des partenaires assureurs==============*/
      getListePartenaire: function () {
        Api().get('partenaire/partners/auto')
          .then(response => {
            this.listeAssureurs = response.data.partenaires
          })
      },
  
      /*=================Crée le tableau de la liste des véhicules==============*/
      createTable: function () {
        if (this.nbAutoAdded == this.nombreVehicules && this.myCars != 'mes_vehicule') {
          if (this.garanties.length >= 1) {
            this.step = 6
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
          } else {
            this.$toasted.show('Veuillez cocher une garantie au minimum ! ', this.ToastTabError)
          }
  
        } else if (!this.nombreVehicules && this.myCars != 'mes_vehicule') {
          if (this.garanties.length >= 1) {
            if (this.ListAuto.length == 0) {
              this.ListAutoCreate()
            }
            this.step = 6
  
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
          } else {
            this.$toasted.show('Veuillez cocher une garantie au minimum ! ', this.ToastTabError)
          }
        } else if (this.myCars == 'mes_vehicule') {
          if (this.garanties.length >= 1) {
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
            this.ListAutoCreateForCars()
            this.step = 6
          } else {
            this.$toasted.show('Veuillez cocher une garantie au minimum ! ', this.ToastTabError)
          }
        }
  
        // if (store.state.isUserLoggedIn) {
        //   this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
        // }
      },
  
      /*=================Verification de la session de l'utilisateur et envoie des donnees==============*/
      SendDataToCreateDevisFlotte: function () {
        if (!store.state.isUserLoggedIn) {
          this.showLoginForm = true
        } else if (store.state.isUserLoggedIn && this.proprietaire) {
          if (this.dateEffet && this.duree) {
            if (this.assureurs.length > 0) {
              /*========== Attemp to save user in the flette ===========*/
              this.SaveUserFlette(store.state.user._id)
              /*========================================================*/
  
              document.getElementById("thirstStep").classList.add('checked');
              document.getElementById("testup").classList.add('widthSix');
              const OneautoToSave = {
                userid: store.state.user._id,
                dateEffet: this.dateEffet,
                createur: store.state.user._id,
                proprietaire: {
                  prenom: '',
                  nom: '',
                  genre: ''
                },
                dateEcheance: this.dateEcheance,
                dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                reference_flotte: this.reference_flotte.id,
                plateforme: 'Front',
                branche: "Automobile",
                duree: this.duree,
                vehicule: this.tableData,
                assureurs: this.assureurs,
                is_devis_flotte : this.is_devis_flotte
              };
  
              if (this.numberMonth() == true) {
                if (this.switch1) {
                  OneautoToSave.proprietaire.prenom = this.$store.state.user.prenom;
                  OneautoToSave.proprietaire.nom = this.$store.state.user.nom
  
                  this.disabledButtonValidate = true
                  this.dialogLoading = true
                  
                  Api().post('devis/add', OneautoToSave)
                    .then(result => {
                      if (result.data.message) {
                        let GtmVal = {
                          branche: 'automobile',
                          entry_point: localStorage.getItem('quoteCreationEntryPoint'),
                          insurer_number: this.assureurs.length,
                          event: 'quote_creation'
                        }
                        PushInDataLayer(GtmVal)
                        this.notifMessage = result.data.message;
                        let data = {
                        ... result.data,
                        duree :this.duree
                      }
                        this.$store.dispatch('setDevis', data);
                          this.dialogLoading = false, 
                          this.disabledButtonValidate = false, 
                          this.$router.push({ name: 'flotteListDevis' })
                      }
                    }).catch(error => {
                      this.$toasted.show(error.response.data.message, this.ToastTabError)
                      this.dialogLoading = false
                      this.disabledButtonValidate = false
                    })
  
                } else {
                  if (this.tableau_info_beneficiaire.length > 0) {
                    OneautoToSave.proprietaire = this.tableau_info_beneficiaire[0]
  
                    this.disabledButtonValidate = true
                    this.dialogLoading = true
                    Api().post('devis/add', OneautoToSave)
                      .then(result => {
                        if (result.data.message) {
                          let GtmVal = {
                            branche: 'automobile',
                            entry_point: localStorage.getItem('quoteCreationEntryPoint'),
                            insurer_number: this.assureurs.length,
                            event: 'quote_creation'
                          }
                          PushInDataLayer(GtmVal)
                          this.notifMessage = result.data.message;
                          let data = {
                        ... result.data,
                        duree :this.duree
                      }
                          this.$store.dispatch('setDevis', data);
                            this.dialogLoading = false, 
                            this.disabledButtonValidate = false, 
                            this.$router.push({ name: 'flotteListDevis' })
                        }
                      }).catch(error => {
                        this.$toasted.show(error.response.data.message, this.ToastTabError)
                        this.dialogLoading = false
                        this.disabledButtonValidate = false
                      })
                  } else {
                    this.dialogInfoBeneficiaire = true
                  }
                }
              } else {
                this.$toasted.show("Le nombre de mois ne doit pas être supérieur a 12!", this.ToastTabError);
                this.duree = '';
              }
            } else {
              this.$toasted.show('Choisissez au moins un assureur !', this.ToastTabError)
            }
          } else {
            this.$toasted.show("Durée et date d'échéance obligatoires ! ", this.ToastTabError)
          }
        } else {
          this.$toasted.show("Nom complet du bénéficiaire obligatoire !", this.ToastTabError)
        }
      },
  
      editAuto(item) {
        this.editedIndex = this.ListAuto.indexOf(item);
        this.editedItem = item;
        this.dialogEditItem = true
      },
  
      close() {
        this.dialogEditItem = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1
        }, 300)
      },
  
      onChangeSelectedMarque() {
        if (typeof this.marque == 'string') {
          if (this.marque == 'AUTRE') {
            this.popupAutre = true;
            this.marque = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Marque': this.marque
            });
            this.listeModeles = selMarque
            this.listeModeles[0] = "AUTRE";
            this.selectedMarque = this.marque
          }
        } else if (typeof this.marque == 'object') {
          if (this.marque == "AUTRE") {
            this.popupAutre = true;
            this.marque = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Marque': this.marque
            });
            this.listeModeles = selMarque;
            this.listeModeles[0] = "AUTRE";
            this.selectedMarque = this.marque;
            this.marque = this.selectedMarque
          }
        }
      },
  
      onChangeSelectedModele: function (mark) {
        if (typeof mark == 'string') {
          if (mark == "AUTRE") {
            this.popupAutre = true;
            this.model = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Type': mark
            });
            this.listeModeles = selMarque;
            this.selectedMarque = mark.Type;
            this.next()
            document.getElementById("testup").classList.add('widthThirt');
          }
        } else if (typeof mark == 'object') {
          if (mark.Type == "AUTRE") {
            this.popupAutre = true;
            this.model = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Type': mark.Type
            });
            this.listeModeles = selMarque;
            this.selectedMarque = mark.Type;
            this.model = this.selectedMarque;
            this.next()
            document.getElementById("testup").classList.add('widthThirt');
          }
        }
      },
  
      onChangeSelectedMarque2roues() {
        if (typeof this.marque == 'string') {
          if (this.marque == "AUTRE") {
            this.popupAutre = true;
            this.marque = ''
          } else {
            let selMarque = _.where(Marque2roues, {
              'Marque': this.marque
            });
            this.listeModeles2roues = selMarque;
            this.listeModeles2roues[0] = "AUTRE"
            this.selectedMarque = this.marque
          }
        } else if (typeof this.marque == 'object') {
          if (this.marque == "AUTRE") {
            this.popupAutre = true;
            this.marque = ''
          } else {
            let selMarque = _.where(Marque2roues, {
              'Marque': this.marque
            });
            this.listeModeles2roues = selMarque;
            this.listeModeles2roues[0] = "AUTRE";
            this.selectedMarque = this.marque;
            this.marque = this.selectedMarque
  
          }
        }
      },
  
      onChangeSelectedModele2roues: function (mark) {
        if (typeof mark == 'string') {
          if (mark == "AUTRE") {
            this.popupAutre = true;
            this.model = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Type': mark
            });
            this.listeModeles = selMarque;
            this.selectedMarque = mark.Type;
            this.e1 = 5
          }
        } else if (typeof mark == 'object') {
          if (mark.Type == "AUTRE") {
            this.popupAutre = true;
            this.model = ''
          } else {
            let selMarque = _.where(MarqueVehicule, {
              'Type': mark.Type
            });
            this.listeModeles = selMarque;
            this.selectedMarque = mark.Type;
            this.model = this.selectedMarque;
            this.e1 = 5
          }
        }
      },
  
      PersoTransporteModalFunction() {
        if (!this.CarToUpdate) {
          let trouver = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'PERSONNES TRANSPORTEES') {
              trouver = 1
            }
          }
          if (trouver == 1) {
            this.PersoTransporteModal = true
          } else {
            this.optionPersoTrans = null
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'PERSONNES TRANSPORTEES') {
              trouver = 1
            }
          }
          if (trouver == 1) {
            this.PersoTransporteModal = true
          } else {
            this.CarToUpdate.optionPersoTrans = null
          }
        }
      },
  
      ValeurNeufModalFunction() {
        if (!this.CarToUpdate) {
          let trouver = 0;
          for (let index = 0; index < this.garanties.length; index++) {
            if (this.garanties[index] == 'TIERCE COMPLETE') {
              trouver = 1
            } else if (this.garanties[index] == 'TIERCE COLLISION') {
              trouver = 2
            }
          }
          if (trouver == 1 || trouver == 2) {
            this.VNeuf = true
          } else {
            this.valeur = this.neant
          }
        } else {
          let trouver = 0;
          for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
            if (this.CarToUpdate.garanties[index] == 'TIERCE COMPLETE') {
              trouver = 1
            } else if (this.CarToUpdate.garanties[index] == 'TIERCE COLLISION') {
              trouver = 2
            }
          }
          if (trouver == 1 || trouver == 2) {
            this.VNeuf = true
          } else {
            this.valeur = this.neant
          }
        }
      },
  
      ValeurNeufModalAddGarantiesFunction() {
        let trouver = 0;
        for (let index = 0; index < this.CarToUpdate.garanties.length; index++) {
          if (this.CarToUpdate.garanties[index] == 'TIERCE COMPLETE') {
            trouver = 1
          } else if (this.CarToUpdate.garanties[index] == 'TIERCE COLLISION') {
            trouver = 2
          }
        }
        if (trouver == 1 || trouver == 2) {
          this.VNeuf = true
        } else {
          this.valeur = this.neant
        }
      },
  
      Individuel_Accident_ModalFunction() {
        if (this.Individuel_Accident_Modal == false) {
          this.Individuel_Accident_Modal = true
        } else {
          this.Individuel_Accident_Modal = false
        }
      },
  
      SaveUserFlette(userid) {
        Api().post('flette/addarray', { car: this.ListAuto, user: userid })
          .then((result) => { console.log(result.data.msg) })
          .catch((err) => { console.log(err) });
      }
    },
  
    computed: {
      progressClasses() {
        let result = 'progress '
        if (this.currentStep && this.currentStep.label === 'complete') {
          return result += 'progress--complete'
        }
        return result += `progress--${this.steps.indexOf(this.currentStep) + 1}`
      },
  
      formTitle() {
        return this.editedIndex === -1 ? 'Nouveau véhicule' : 'Modification du véhicule'
      },
  
      /*=================proprieté permettant de selectionner touts les assureurs à la fois ==============*/
      selectAll: {
        get: function () {
          return this.listeAssureurs ? this.selected.length == this.listeAssureurs.length : false;
        },
        set: function (value) {
          const assureurs = [];
  
          if (value) {
            this.listeAssureurs.forEach(function (assure) {
              assureurs.push(assure.societe);
            });
          }
          this.assureurs = assureurs;
        }
      }
    },
  
    watch: {
      dialog(val) {
        val || this.close()
      },
  
      model(val) {
        if (typeof val == 'object') {
          this.model = val.Type
        } else if (typeof val == 'string') {
          this.model = val
        }
      },
  
      showLoginForm(val) {
        if (val == false) {
          if (store.state.isUserLoggedIn) {
            this.getUserCars()
            this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
          }
        }
      },
  
      assureurs(val)
      {
        let checker  = false
        for(let v of val){
          if(v=="SANLAM" && this.duree < 6){
            for(let a of this.ListAuto)
            {
                for(let g of a.garanties)
                {
                  if(g.toUpperCase()=="AVANCE SUR RECOURS")
                  {
                    checker  = true
                  }
                }
            }
          }
        }
  
        if(checker){
          this.$toasted.show("Pour SANLAM, la garantie AVANCE SUR RECOURS  n'est posible qu'à partir de 6 mois de durée !", this.ToastTabErrorSpec)
        }
  
      }
    },
  
    mounted: function () {
      window.scrollTo(0, 0);
      this.checkToken()
      if (store.state.isUserLoggedIn) {
        this.getUserCars()
      } else {
        console.log("the user isn't connected")
      }
      this.getListePartenaire()
      esk('track', 'Conversion');
  
    },
    created() {
      this.GarantiesBase = configAuto.Garanties;
      this.Garanties2roues = configAuto.Garanties2roues
    }
  }
  </script>
  
  <style lang="less" scoped>
  @import "../../assets/css/button.css";
  @import "../../assets/css/devis_css.css";
  
  .shadow_card {
    box-shadow: 9px 12px 18px rgb(0 0 0 / 5%);
  }
  
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 15px;
  }
  
  .form {
    background-color: #fff;
    padding: 1.5rem;
  }
  
  .form .page {
    height: auto;
  }
  
  button.next {
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: 1.5rem;
    margin-bottom: 1rem;
  }
  
  button.previous {
    position: absolute;
    bottom: 0;
    left: 0;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
  }
  
  
  button.edit {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  
  h4 {
    color: #29323a;
    margin-bottom: 15px;
    font-weight: 600;
  }
  
  
  
  
  html {
    background-color: #1a1a1a;
    overflow: hidden;
  }
  
  .middle {
    width: auto;
    text-align: center;
    /* Made by */
  }
  
  .middle h1 {
    font-family: "Inter", sans-serif;
    color: #fff;
  }
  
  .middle input[type="radio"] {
    display: none;
  }
  
  .middle input[type="radio"]:checked+.box {
    background-color: rgba(255, 164, 9, 0.07);
    transition: all .33s ease;
    border: 2px solid #ffa409;
    color: #29323a;
  }
  
  .middle input[type="radio"]:checked+.box span {
    color: #29323a;
    transform: translateY(70px);
  }
  
  .middle input[type="radio"]:checked+.box span:before {
    transform: translateY(0px);
    opacity: 1;
  }
  
  .middle .box {
    width: 220px;
    height: 150px;
    border-radius: 12px;
    background-color: #fff;
    transition: all 250ms ease;
    will-change: transition;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
    font-size: 10px;
    border: 1px solid #d9dee3;
    font-family: Open Sans, sans-serif;
    font-weight: 900;
  }
  
  .middle .box:hover {
    background-color: rgba(255, 164, 9, 0.07);
    transition: all .33s ease;
    border: 2px solid #ffa409;
  }
  
  .middle .box:hover span {
    color: #29323a;
  }
  
  .middle .box:active {
    transform: translateY(10px);
  }
  
  .middle .box span {
    position: absolute;
    transform: translate(0, 60px);
    left: 0;
    right: 0;
    padding-top: 15%;
    transition: all 300ms ease;
    font-size: 1.5em;
    user-select: none;
    color: #29323a;
  }
  
  .middle .box span:before {
    font-size: 1.2em;
    font-family: FontAwesome;
    display: block;
    transform: translateY(-80px);
    opacity: 0;
    transition: all 300ms ease-in-out;
    font-weight: normal;
    color: #fff;
  }
  
  .middle p {
    color: #fff;
    font-family: "Inter", sans-serif;
    font-weight: 400;
  }
  
  .middle p a {
    text-decoration: underline;
    font-weight: bold;
    color: #fff;
  }
  
  .middle p span:after {
    content: "\f0e7";
    font-family: FontAwesome;
    color: yellow;
  }
  
  .widthFirst {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 50%;
  }
  
  .widthSecond {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 16.11112%;
  }
  
  .widthThirt {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 24.11112%;
  }
  
  .widthFour {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 33.11112%;
  }
  
  .widthFive {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 65%;
  }
  
  .widthSix {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 100%;
  }
  
  .paralax-cover-image {
    background-image: url('../../assets/img/assurance/auto.jpg');
    position: relative;
    background-size: contain !important;
    background-position: 50%;
    min-height: 230px;
    width: 100%;
    margin: 0 0 0;
    display: flex;
    /*padding: 20px;*/
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
  
  }
  
  .paralax-cover-image p {
    color: rgb(255, 255, 255);
    font-size: 20px;
    font-weight: 300;
  }
  
  .paralax-cover-image .paralax-cover-image-text,
  .paralax-cover-image h2 {
    color: #fff;
    font-size: 2em;
    line-height: 1.25;
    z-index: 1;
    margin-bottom: 0;
    max-width: 610px;
    text-align: center;
    margin-left: 8.5%;
  }
  
  .paralax-cover-image.has-background-dim:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .paralax-cover-image {
    background-attachment: fixed;
    background-position: 50% 40px;
  }
  
  
  
  .paralax-cover-image_mobile {
    background-image: url('../../assets/img/assurance/auto_mobile.jpg');
    position: relative;
    background-size: contain;
    background-position: 50%;
    min-height: 150px;
    width: 100%;
    margin: 0 0 0;
    display: flex;
    //padding: 20px;
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
  
  }
  
  .paralax-cover-image_mobile p {
    color: rgb(255, 255, 255);
    font-size: 20px;
    font-weight: 300;
    padding-bottom: 20Px;
  }
  
  .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
  .paralax-cover-image_mobile h2 {
    color: #fff;
    font-size: 2em;
    line-height: 1.25;
    z-index: 1;
    margin-bottom: 0;
    max-width: 610px;
    text-align: center;
    margin-left: 8.5%;
  }
  
  .paralax-cover-image_mobile.has-background-dim_mobile:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .paralax-cover-image_mobile {
    // background-attachment: fixed;
    background-position: 100% 40px;
  }
  
  
  .hero {
    position: relative;
    background-size: cover;
    background-position: center center;
    height: 680px;
    min-height: 320px;
    max-height: 100%;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
    -ms-flex-pack: center;
    padding: 20px;
  }
  
  .hero .content_home {
    position: relative;
    min-height: 280px;
    width: 100%;
    margin-left: 8.5%;
    z-index: 2;
    /*//background: red;*/
  }
  
  .hero .content_home p {
    color: rgb(255, 255, 255);
    font-size: 20px;
    font-weight: 300;
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  
  
  /*== start of code for tooltips ==*/
  .tool {
    cursor: help;
    position: relative;
  }
  
  
  /*== common styles for both parts of tool tip ==*/
  .tool::before,
  .tool::after {
    left: 50%;
    opacity: 0;
    position: absolute;
    z-index: -100;
  }
  
  .tool:hover::before,
  .tool:focus::before,
  .tool:hover::after,
  .tool:focus::after {
    opacity: 1;
    transform: scale(1) translateY(0);
    z-index: 100;
  }
  
  
  /*== pointer tip ==*/
  .tool::before {
    border-style: solid;
    border-width: 1em 0.75em 0 0.75em;
    border-color: #565C61 transparent transparent transparent;
    bottom: 105%;
    content: "";
    margin-left: -0.5em;
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26), opacity .65s .5s;
    transform: scale(.6) translateY(-90%);
  }
  
  .tool:hover::before,
  .tool:focus::before {
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
  }
  
  
  
  /*== speech bubble ==*/
  .tool::after {
    background: #565C61;
    border-radius: .25em;
    bottom: 120%;
    color: #EDEFF0;
    font-size: 15px;
    content: attr(data-tip);
    margin-left: -8.75em;
    padding: 1em;
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
    transform: scale(.6) translateY(50%);
    width: 17.5em;
  
  }
  
  .tool:hover::after,
  .tool:focus::after {
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26);
  }
  
  @media (max-width: 760px) {
    .tool::after {
      font-size: .75em;
      margin-left: -5em;
      width: 10em;
    }
  }
  
  // css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}

.lightning-box {
    position: absolute;
    bottom: 15px;
    width: 30px;
    right: 10px!important;
}


.drop-container {
  display:-webkit-box;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -ms-flex-direction:column;
  flex-direction:column;
  -webkit-box-pack:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -ms-flex-align:center;
  align-items:center;
  gap:10px;
  width:100%;
  padding:20px;
  border:2px dashed #000;
  border-radius:10px;
  background-color:#fefbf6;
  color:#000;
  cursor:pointer;
  -webkit-transition:background .2s ease-in-out,border .2s ease-in-out;
  transition:background .2s ease-in-out,border .2s ease-in-out
}
.drop-container:hover {
  background-color:#fbc162
}
.drop-title {
  color:#222245!important;
  font-size:20px;
  font-weight:700;
  text-align:center
}
.drop-subtitle {
  color:#222245!important;
  font-size:15px;
  font-weight:500;
  text-align:center
}
input[type=file] {
  width:350px;
  max-width:100%;
  color:#222245;
  padding:8px;
  background-color:#fff;
  border:1px solid #222245;
  border-radius:10px
}
input[type=file]:focus {
  outline-offset:2px
}
input[type=file]::file-selector-button {
  margin-right:8px;
  border:none;
  border-radius:10px;
  background-color:#f4ac39;
  padding:8px 12px;
  color:#000;
  font-size:15px;
  cursor:pointer
}
input[type=file]::file-selector-button:hover {
  background-color:#ffa409
}






.insurers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .insurers-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.insurer-card {
  position: relative;
  border-radius: 12px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.insurer-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #cbd5e0;
}

.insurer-card.selected {
  border-color: #ffa409;
  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 100%);
  box-shadow: 0 4px 20px rgba(255, 164, 9, 0.2);
}

.insurer-card.all-insurers {
  background: linear-gradient(135deg, #ffa409 0%, #ff8c00 100%);
  border-color: #ffa409;
  color: white;
}

.insurer-card.all-insurers.selected {
  background: linear-gradient(135deg, #e69500 0%, #cc7a00 100%);
  transform: scale(1.02);
}

.insurer-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.insurer-label {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
}

.insurer-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border-radius: 12px;
  margin-right: 1rem;
  transition: all 0.3s ease;
}

.insurer-card.selected .insurer-icon {
  background: rgba(255, 164, 9, 0.1);
}

.insurer-card.all-insurers .insurer-icon {
  background: rgba(255, 255, 255, 0.2);
}

.insurer-logo {
  max-width: 45px;
  max-height: 45px;
  object-fit: contain;
  filter: brightness(1);
  transition: all 0.3s ease;
}

.insurer-card.all-insurers .insurer-logo {
  filter: brightness(0) invert(1);
}

.insurer-info {
  flex: 1;
  min-width: 0;
}

.insurer-name {
  font-size: 1rem;
  font-weight: 500;
  color: #2d3748;
  margin: 0 0 0.25rem 0;
  line-height: 1.2;
  word-break: break-word;
}

.insurer-card.all-insurers .insurer-name {
  color: white;
}

.insurer-badge {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 500;
  color: #718096;
  background: #edf2f7;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.insurer-card.all-insurers .insurer-badge {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.insurer-card.selected .insurer-badge {
  background: rgba(255, 164, 9, 0.2);
  color: #b45309;
}

.selection-indicator {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  opacity: 0;
  transform: scale(0.8);
}

.insurer-card.selected .selection-indicator {
  opacity: 1;
  transform: scale(1);
  background: #ffa409;
  color: white;
}

.selection-indicator i {
  font-size: 0.75rem;
}

.selection-summary {
  background: linear-gradient(135deg, #e6fffa 0%, #f0fff4 100%);
  border: 1px solid #9ae6b4;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.summary-content {
  display: flex;
  align-items: center;
  color: #2f855a;
  font-weight: 500;
}

.summary-content i {
  margin-right: 0.5rem;
  font-size: 1.1rem;
}

/* Animation d'entrée */
.insurer-card {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animation pour les cartes sélectionnées */
.insurer-card.selected {
  animation: pulse 0.6s ease-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}

/* Responsive amélioré */
@media (max-width: 480px) {
  .insurer-label {
    padding: 1rem;
  }
  
  .insurer-icon {
    width: 50px;
    height: 50px;
    margin-right: 0.75rem;
  }
  
  .insurer-logo {
    max-width: 35px;
    max-height: 35px;
  }
  
  .insurer-name {
    font-size: 1.4rem;
  }
  
  .modern-title {
    font-size: 1.1rem;
  }
}

/* Amélioration de l'accessibilité */
.insurer-card:focus-within {
  //outline: 2px solid #ffa409;
  outline-offset: 2px;
}

.insurer-input:focus + .insurer-label {
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.3);
}

/* États de chargement */
.insurers-grid.loading .insurer-card {
  opacity: 0.6;
  pointer-events: none;
}
  </style>
  